import { registerSettings, registerPreset } from './settings-service.svelte.js'
import { builtInPresets } from './presets.js'
import type { SettingsContribution } from './types.js'

let initialized = false

export function initSettings(): void {
	if (initialized) return
	initialized = true

	for (const preset of builtInPresets) {
		registerPreset(preset)
	}

	fetchAndRegisterContributions()
}

function fetchAndRegisterContributions(): void {
	fetch('/api/shared/settings')
		.then((res) => {
			if (!res.ok) throw new Error('Failed to fetch settings contributions')
			return res.json() as Promise<SettingsContribution[]>
		})
		.then((contributions) => {
			for (const contribution of contributions) {
				registerSettings(contribution)
			}
		})
		.catch((err) => {
			console.warn('[settings] Failed to load contributions:', err)
		})
}
